export default __webpack_public_path__ + "static/media/(4).4f43db2e.jpg";